var render, staticRenderFns
import script from "./EmailCellRenderer.vue?vue&type=script&lang=js"
export * from "./EmailCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./EmailCellRenderer.vue?vue&type=style&index=0&id=7279d10c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7279d10c",
  null
  
)

export default component.exports